import '@/assets/scss/adaptWrapper.scss'
import { deviceType } from '@/utils/common'
import BlankLayout from '@/views/personalNew/layout/blankLayout.vue'
import ChangeMobile from './pc/functions/changeMobile/index.vue'
import ChangeEmail from './pc/functions/changeEmail/index.vue'
import PcChangePassword from './pc/functions/changePassword/index.vue'

import MobileChangePassword from './mobile/functions/changePassword.vue'

const basePath = '/recruiting/personal/functions'

const pcChangePasswordRoute = {
  path: `${basePath}/change-password/`,
  component: PcChangePassword,
  meta: {
    titleI18nKey: 'personal.menu.changePassword'
  }
}

const mobileChangePasswordRoute = {
  path: `${basePath}/change-password/`,
  component: MobileChangePassword,
  meta: {
    titleI18nKey: 'personal.menu.changePassword',
    mobileFlexible: true,
    mobileHomeMenu: {
      isInclude: true,
      iconClass: 'iconreset',
      descI18nKey: 'personal.resetPassword.homeMenu.desc',
      nameI18nKey: 'personal.resetPassword.homeMenu.name'
    }
  }
}

export default {
  path: `${basePath}`,
  component: BlankLayout,
  meta: {
    isAllInclude: true,
    menuI18nKey: 'personal.menu.group.functions'
  },
  children: [
    {
      name: 'changeEmail',
      path: `${basePath}/change-email/`,
      component: ChangeEmail,
      meta: {
        checkHasEmail: true,
        titleI18nKey: 'personal.menu.changeEmail',
        checkFailI18nKey: 'personal.menu.bindEmail'
      }
    },
    {
      path: `${basePath}/change-mobile/`,
      component: ChangeMobile,
      meta: {
        checkHasMobile: true,
        titleI18nKey: 'personal.menu.changeMobile',
        checkFailI18nKey: 'personal.menu.bindMobile'
      }
    },
    deviceType.isPc ? pcChangePasswordRoute : mobileChangePasswordRoute
  ]
}

export { pcChangePasswordRoute, mobileChangePasswordRoute }
